import React from "react";
import "../App.css";
import MyModal from "./MyModal.js";
import { FaLinkedin } from "react-icons/fa";

export const Footer = () => {
  return (
    <div className="footer">
      <div className="links">
        <a
          href="https://www.linkedin.com/in/emma-svensson-arn%C3%A9r-14bb0921a/"
          target="_blank"
          rel="noreferrer"
        >
          <FaLinkedin className="icon"></FaLinkedin>
        </a>
        <MyModal/>
      </div>
    </div>
  );
};
